import { render, staticRenderFns } from "./imDialog.vue?vue&type=template&id=0ca28908&scoped=true"
import script from "./imDialog.vue?vue&type=script&lang=js"
export * from "./imDialog.vue?vue&type=script&lang=js"
import style0 from "./imDialog.vue?vue&type=style&index=0&id=0ca28908&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca28908",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ca28908')) {
      api.createRecord('0ca28908', component.options)
    } else {
      api.reload('0ca28908', component.options)
    }
    module.hot.accept("./imDialog.vue?vue&type=template&id=0ca28908&scoped=true", function () {
      api.rerender('0ca28908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialog/imDialog.vue"
export default component.exports